<template>
  <div class="pricing-item">
    <div class="pricing-item-top">
      <div class="pricing-item-header">
        <div class="pricing-item-title">
          {{ priceData.title }}
        </div>
        <div class="pricing-item-price">
          {{ priceData.price }}
        </div>
      </div>
      <div class="pricing-item-desc">
        <span>{{ priceData.desc }}</span>
        <span>{{ priceData.price_desc }}</span>
      </div>
      <div class="pricing-item-plan">
        <IconPriceStar />
        <div v-html="priceData.plan"></div>
      </div>
      <v-btn
        color="#600DFF"
        class="hero-cta white--text pricing-item-btn"
        elevation="0"
      >
        {{ priceData.btnText }}
      </v-btn>
    </div>
    <div class="pricing-item-body">
      <div class="pricing-item-specs">
        <h4>{{ priceData.title }} <span>plan includes: </span></h4>
        <div class="pricing-item-spec">
          <IconTick />
          <span>Lorem ipsum </span>
        </div>
        <div class="pricing-item-spec">
          <IconTick />
          <span>Lorem ipsum dolor sit </span>
        </div>
        <div class="pricing-item-spec pricing-item-spec-bold">
          <IconTick />
          <span>Lorem ipsum </span>
        </div>
        <div class="pricing-item-spec pricing-item-spec-bold">
          <IconTick />
          <span>Lorem ipsum dolor sit </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    priceData: {
      type: Object,
      required: true,
    },
  },
  components: {
    IconPriceStar: () => import("@/components/icons/IconPriceStar"),
    IconTick: () => import("@/components/icons/IconTick"),
  },
};
</script>

<style lang="scss">
.pricing-item {
  background-color: #fff;
  border-radius: 8px;
  padding: 25px 0;
  padding-bottom: 100px;

  .hero-cta {
    width: 100%;
  }

  &-top {
    padding: 0 24px;
  }

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 7px;
  }
  &-title {
    font-size: 24px;
    font-weight: bold;
    color: $primary-color;
  }
  &-price {
    font-size: 24px;
    font-weight: bold;
  }
  &-desc {
    font-size: 12px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }
  &-plan {
    display: flex;
    align-items: center;
    font-size: 14px;
    background-color: #f6f6f6;
    border-radius: 4px;
    padding: 11px 14px;
    margin-bottom: 16px;

    .icon {
      margin-right: 14px;
    }
  }
  &-btn {
    width: 100%;
    margin-bottom: 16px;
    border-radius: 4px !important;
    height: 36px !important;

    span {
      color: #fff;
      font-weight: bold;
      text-transform: none;
      font-size: 16px !important;
      letter-spacing: 0;
    }
  }
  &-body {
    border-top: 1px solid #f6f6f6;
    padding: 25px 24px;
  }
  &-specs {
    h4 {
      font-size: 12px;
      margin-bottom: 20px;
      span {
        color: #8b8b8b;
      }
    }
  }
  &-spec {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 2px;
    .icon {
      margin-right: 12px;
    }
    &-bold {
      font-weight: bold;
    }
  }
}

@include smMax {
  .pricing-item {
    padding: 18px;
    width: 280px;
    margin: 0 auto;

    &-top {
      padding: 10px;
    }

    &-btn {
      width: 228px !important;
    }
  }
}
</style>
